import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { ROUTES } from '../../../routes/constants';
import { DEMO_WHATSAPP_URL } from './webinarConfig';

export default function ThankYouPage() {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const previousTitle = document.title;
    document.title = "You're Registered | AlgoSys";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="auth-font-body relative flex min-h-screen flex-col items-center justify-center bg-bg-base px-4 py-16 text-txt-primary">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 left-1/2 h-[500px] w-[700px] -translate-x-1/2 rounded-full bg-amber/[0.06] blur-[120px]" />
        <div className="absolute -bottom-32 -right-32 h-[500px] w-[500px] rounded-full bg-info/[0.05] blur-[100px]" />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        <div className="relative overflow-hidden rounded-xl border border-bg-border/60 bg-bg-panel p-6 text-center shadow-modal md:p-10">
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber/50 to-transparent" />

          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber/10">
            <CheckCircle2 size={30} className="text-amber" />
          </div>

          <h1 className="auth-font-heading mt-6 text-2xl font-bold text-txt-primary md:text-3xl">
            You&apos;re registered. Check your email and WhatsApp for the joining details.
          </h1>

          <p className="mt-4 text-sm leading-relaxed text-txt-secondary md:text-base">
            We will send the joining link before the session. Please attend live — the recording
            will not be shared publicly. Bring one TradingView alert or Pine Script strategy you
            want to automate.
          </p>

          <a
            href={DEMO_WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-secondary mt-8 inline-flex w-full justify-center md:w-auto"
          >
            Can&apos;t wait for the webinar? Book your free 1-on-1 setup demo now.
          </a>

          <div className="mt-6">
            <Link to={ROUTES.TRADINGVIEW_LANDING} className="text-xs font-semibold text-amber underline underline-offset-2">
              Back to the webinar page
            </Link>
          </div>
        </div>

        <p className="mt-8 max-w-lg text-center text-xs leading-relaxed text-txt-muted">
          AlgoSys is a technology platform for trading automation. It does not provide investment
          advice, trading tips, portfolio management, or guaranteed returns. Trading involves
          market risk.
        </p>
      </div>
    </main>
  );
}
